import { jsx as _jsx } from "react/jsx-runtime";
import { ProductStub } from '../ProductStub';
/** URL Shortener Reports — aggregate click analytics across all links. */
export function ReportsPage() {
    return (_jsx(ProductStub, { title: "Reports", blurb: "Click analytics across every link \u2014 totals over time, top links, and geo / referrer / device / UTM breakdowns, with exportable reports. Per-link analytics already live under each link; this rolls them up org-wide. Ships in a later wave." }));
}
